module.exports = __webpack_public_path__ + "static/media/McMaster.02006966.png";